import { Component, OnInit } from '@angular/core';
import { BrandService } from '../../../../services/brand.service';

@Component({
    selector: 'app-form-flow-shell',
    templateUrl: './form-flow-shell.component.html',
    styleUrls: ['./form-flow-shell.component.scss'],
    standalone: false
})
export class FormFlowShellComponent implements OnInit {
  removeTrackers: boolean = false;
  constructor(public brandService: BrandService) { }

  ngOnInit() {
    this.removeTrackers = !!window['removeTrackers'] || document.cookie.split(';').some(cookie => cookie.trim().startsWith('fruRemoveCookies'));
  }

}
